import { useMutation, useQueryClient } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { MaterialPayload, MaterialResource } from "../types";

const createMaterial = async (payload: MaterialPayload) => {
  const { material } = (await stellar.action("createMaterial", payload)) as {
    material: MaterialResource;
  };

  return material;
};

export const useCreateMaterialMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMaterial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["materials"] });
    },
  });
};
